import axios from 'axios';

const createPayment = (data) => axios.post('v1/users/checkout', data);
const submitCashPayment = (data) => axios.put('v1/users/checkout', data);

const PaymentsAPI = { createPayment, submitCashPayment };

export default PaymentsAPI;
